// Ürün verileri - Yeni fiyat bilgileri ve kondisyonlar ile güncellenmiş
export interface ProductData {
  id: number;
  name: string;
  slug: string;
  brand: string;
  newPrice: number; // Sıfır ürün fiyatı (USD)
  salePrice: number; // Satış fiyatı (TL)
  condition: 'Like New' | 'Very Good' | 'Good' | 'Old but Good';
  category: 'Shoes' | 'Clothing' | 'Jackets' | 'Shirts' | 'T-Shirts' | 'Special';
  size?: string;
  isSecondHand: boolean;
  url: string;
  description?: string;
  specifications?: string[];
}

export const updatedProductData: ProductData[] = [
  // Ayakkabılar
  {
    id: 1,
    name: 'Beymen Suede Penny Loafers — Taupe/Beige (EU 42, Second-Hand)',
    slug: 'beymen-suede-penny-loafers-taupebeige-eu-42-second-hand',
    brand: 'Beymen',
    newPrice: 282,
    salePrice: 2500,
    condition: 'Like New',
    category: 'Shoes',
    size: 'EU 42',
    isSecondHand: true,
    url: 'https://barkinsayin.com/store/shoes/beymen-suede-penny-loafers-taupebeige-eu-42-second-hand',
    description: 'Elegant Beymen loafers in soft, premium suede with classic penny strap and clean almond toe. Versatile taupe tone pairs effortlessly with smart-casual looks.',
    specifications: ['Upper: genuine suede leather', 'Lining & insole: leather (Beymen stamped footbed)', 'Outsole: leather (low stacked heel)', 'Penny strap, apron stitching, slip-on convenience', 'Color: Taupe / light beige', 'EU 42 (US 9 / UK 8) — standard width', 'Approx. insole length 27.5–28.0 cm; heel height ~2.5 cm', 'Condition: Very good - light, even wear on sole; uppers clean with minor, normal suede rubbing', 'Care: Brush with a suede brush; use suede protector spray']
  },
  {
    id: 2,
    name: 'Saint Laurent High-Top Sneakers — White (EU 42, Second-Hand)',
    slug: 'saint-laurent-high-top-sneakers-white-eu-42-second-hand',
    brand: 'Saint Laurent',
    newPrice: 899,
    salePrice: 9500,
    condition: 'Like New',
    category: 'Shoes',
    size: 'EU 42',
    isSecondHand: true,
    url: 'https://barkinsayin.com/store/shoes/saint-laurent-high-top-sneakers-white-eu-42-second-hand',
    description: 'Clean, minimalist Saint Laurent high-tops in white leather with perforated panels and side logo. A sharp, easy pair for everyday city wear.',
    specifications: ['Upper: genuine leather with perforated quarters', 'Lace-up high-top profile, padded tongue & collar', 'Side branding: SAINT LAURENT', 'Cupsole: durable rubber with translucent foxing', 'Color: White / off-white', 'EU 42 (US 9 / UK 8) — standard width', 'Insole length approx. 27.5–28.0 cm', 'Condition: Good/Very good - light wear to outsole and foxing; uppers clean with minor creasing', 'Care: Wipe with damp cloth; use colorless leather cream']
  },
  {
    id: 3,
    name: 'New Balance Retro Runner – Black (EU 42, Second-Hand)',
    slug: 'new-balance-retro-runner-black-eu-42-second-hand',
    brand: 'New Balance',
    newPrice: 110,
    salePrice: 1900,
    condition: 'Like New',
    category: 'Shoes',
    size: 'EU 42',
    isSecondHand: true,
    url: 'https://barkinsayin.com/store/shoes/new-balance-retro-runner-black-eu-42-second-hand',
    description: 'Lightweight New Balance sneakers in black suede/mesh—everyday comfort with that classic NB runner look.',
    specifications: ['Upper: suede + mesh panels (breathable, durable)', 'Cushioning: EVA/foam midsole for all-day comfort', 'Outsole: grippy rubber with traction lugs', 'Closure: lace-up; padded tongue & collar', 'Color: Black / charcoal', 'EU 42 (US 9 / UK 8) — standard width', 'Insole length approx. 27.5–28.0 cm', 'Condition: Very good - minor wear on outsole edges; uppers clean', 'Care: Brush suede with a soft brush; spot-clean mesh']
  },
  {
    id: 4,
    name: 'Versace Jeans Couture Logo Sneakers – Black/Gold (EU 42, Second-Hand)',
    slug: 'versace-jeans-couture-logo-sneakers-blackgold-eu-42-second-hand',
    brand: 'Versace Jeans Couture',
    newPrice: 340,
    salePrice: 3000,
    condition: 'Good',
    category: 'Shoes',
    size: 'EU 42',
    isSecondHand: true,
    url: 'https://barkinsayin.com/store/shoes/versace-jeans-couture-logo-sneakers-blackgold-eu-42-second-hand',
    description: 'Bold VJC sneakers with oversized VERSACE JEANS COUTURE branding across the knit upper. Lightweight, cushioned, and perfect for statement streetwear looks.',
    specifications: ['Upper: breathable engineered knit/mesh with logo print; synthetic overlays', 'Midsole: lightweight EVA/foam for everyday comfort', 'Outsole: rubber with traction pattern', 'Lace-up closure; pull tabs', 'Color: Black with gold logo', 'EU 42 (US 9 / UK 8) – standard width', 'Insole length approx. 27.5–28.0 cm', 'Condition: Very good - light wear on soles; uppers clean', 'Care: Spot clean knit by hand; avoid machine wash']
  },
  {
    id: 5,
    name: 'Camper Lace-Up Boots – Black (EU 42, Second-Hand)',
    slug: 'camper-lace-up-boots-black-eu-42-second-hand',
    brand: 'Camper',
    newPrice: 170,
    salePrice: 1500,
    condition: 'Good',
    category: 'Shoes',
    size: 'EU 42',
    isSecondHand: true,
    url: 'https://barkinsayin.com/store/shoes/camper-lace-up-boots-black-eu-42-second-hand',
    description: 'Minimal, city-ready boots with Camper\'s signature mix of comfort and utility. Smooth black leather, lace-up front, and a sturdy rubber sole for everyday wear.',
    specifications: ['Upper: smooth leather in black', 'Closure: lace-up front; back pull tab', 'Lining: comfortable textile/leather mix', 'Outsole: grippy rubber with low, stable profile', 'Round toe; clean, modern silhouette', 'EU 42 (US 9 / UK 8) – regular width', 'Approx. insole length 27.5–28.0 cm', 'Condition: Very good - minor creasing on leather and light outsole wear', 'Care: Brush off dust; wipe with damp cloth; condition leather occasionally']
  },
  {
    id: 6,
    name: 'Giuseppe Zanotti High-Top – Croc Embossed (EU 42, Pre-Owned)',
    slug: 'giuseppe-zanotti-high-top-croc-embossed-eu-42-pre-owned',
    brand: 'Giuseppe Zanotti',
    newPrice: 620,
    salePrice: 8500,
    condition: 'Like New',
    category: 'Shoes',
    size: 'EU 42',
    isSecondHand: true,
    url: 'https://barkinsayin.com/store/shoes/giuseppe-zanotti-high-top-croc-embossed-eu-42-pre-owned',
    description: 'Striking black croc-embossed high-tops with gold side zips and signature tongue logo. Sporty-elegant—perfect for statement looks.',
    specifications: ['Upper: Black croc-embossed leather', 'Closure: Laces + side zippers', 'Interior: Leather/textile, padded collar', 'Sole: White rubber cupsole', 'Branding: Signature metal logo on tongue', 'EU 42 (US 9 / UK 8) — standard width', 'Insole: approx. 27.5–28.0 cm', 'Condition: Very good - light wear on sole, minor creasing on leather', 'Care: Wipe with a soft cloth; condition leather occasionally']
  },
  {
    id: 7,
    name: 'Camper Ankle Boots – Black Leather (EU 42, Pre-owned)',
    slug: 'camper-ankle-boots-black-leather-eu-42-pre-owned',
    brand: 'Camper',
    newPrice: 210,
    salePrice: 1250,
    condition: 'Old but Good',
    category: 'Shoes',
    size: 'EU 42',
    isSecondHand: true,
    url: 'https://barkinsayin.com/store/shoes/camper-ankle-boots-black-leather-eu-42-pre-owned',
    description: 'Understated, sturdy black leather ankle boots with a chunky ribbed rubber rand and pull-on tabs. Minimal design, everyday comfort.',
    specifications: ['Smooth black leather uppers', 'Pull-on style with dual heel/tongue tabs', 'Protective ribbed rubber rand & grippy outsole', 'Round toe, clean seams, low profile heel', 'Upper: leather', 'Lining: leather/textile', 'Outsole: rubber', 'EU 42 (US 9 / UK 8) — standard width', 'Insole approx. 27.5–28.0 cm', 'Condition: Very good - light creasing to leather, minor wear on outsole', 'Care: Wipe with a soft cloth; nourish leather periodically']
  },
  {
    id: 8,
    name: 'DSQUARED2 Retro Runner – Black/White (EU 42, Pre-owned)',
    slug: 'dsquared2-retro-runner-blackwhite-eu-42-pre-owned',
    brand: 'DSQUARED2',
    newPrice: 450,
    salePrice: 4450,
    condition: 'Good',
    category: 'Shoes',
    size: 'EU 42',
    isSecondHand: true,
    url: 'https://barkinsayin.com/store/shoes/dsquared2-retro-runner-blackwhite-eu-42-pre-owned',
    description: 'Classic DSQUARED2 retro runner in black and white colorway. Comfortable cushioning with vintage-inspired design.',
    specifications: ['Upper: Leather and mesh combination', 'Midsole: EVA foam cushioning', 'Outsole: Rubber with traction pattern', 'Lace-up closure', 'Color: Black/White', 'EU 42 (US 9 / UK 8)', 'Condition: Good - normal wear, clean uppers', 'Care: Spot clean; air dry']
  },
  {
    id: 9,
    name: 'Dolce & Gabbana Court Sneakers – White/Gold/Black (EU 42, Pre-owned)',
    slug: 'dolce-gabbana-court-sneakers-whitegoldblack-eu-42-pre-owned',
    brand: 'Dolce & Gabbana',
    newPrice: 899,
    salePrice: 8500,
    condition: 'Good',
    category: 'Shoes',
    size: 'EU 42',
    isSecondHand: true,
    url: 'https://barkinsayin.com/store/shoes/dolce-gabbana-court-sneakers-whitegoldblack-eu-42-pre-owned',
    description: 'Luxury D&G court sneakers with gold and black accents on white leather. Premium Italian craftsmanship.',
    specifications: ['Upper: Premium leather', 'Gold and black detailing', 'Lace-up front', 'Rubber cupsole', 'Color: White/Gold/Black', 'EU 42 (US 9 / UK 8)', 'Condition: Good - light wear, minor creasing', 'Care: Wipe with soft cloth; leather conditioner']
  },
  {
    id: 10,
    name: 'Giuseppe Zanotti Woven Slip-On Loafers – Navy (EU 42, Pre-owned)',
    slug: 'giuseppe-zanotti-woven-slip-on-loafers-navy-eu-42-pre-owned',
    brand: 'Giuseppe Zanotti',
    newPrice: 699,
    salePrice: 7500,
    condition: 'Like New',
    category: 'Shoes',
    size: 'EU 42',
    isSecondHand: true,
    url: 'https://barkinsayin.com/store/shoes/giuseppe-zanotti-woven-slip-on-loafers-navy-eu-42-pre-owned',
    description: 'Elegant woven slip-on loafers in navy from Giuseppe Zanotti. Sophisticated texture and effortless style.',
    specifications: ['Upper: Woven leather', 'Slip-on design', 'Leather lining and insole', 'Rubber outsole', 'Color: Navy blue', 'EU 42 (US 9 / UK 8)', 'Condition: Like New - minimal wear', 'Care: Brush gently; avoid water']
  },
  {
    id: 11,
    name: 'Louis Vuitton Monogram Driver Loafers – Blue (EU 42, Pre-owned)',
    slug: 'louis-vuitton-monogram-driver-loafers-blue-eu-42-pre-owned',
    brand: 'Louis Vuitton',
    newPrice: 799,
    salePrice: 12500,
    condition: 'Like New',
    category: 'Shoes',
    size: 'EU 42',
    isSecondHand: true,
    url: 'https://barkinsayin.com/store/shoes/louis-vuitton-monogram-driver-loafers-blue-eu-42-pre-owned',
    description: 'Iconic Louis Vuitton driver loafers featuring monogram canvas in blue. Luxury comfort for everyday wear.',
    specifications: ['Upper: LV monogram canvas', 'Leather trim and lining', 'Rubber pebble outsole', 'Slip-on style', 'Color: Blue with monogram', 'EU 42 (US 9 / UK 8)', 'Condition: Like New - excellent condition', 'Care: Wipe canvas with damp cloth']
  },
  {
    id: 12,
    name: 'Gucci GG Leather Espadrilles – Blue (EU 42, Pre-owned)',
    slug: 'gucci-gg-leather-espadrilles-blue-eu-42-pre-owned',
    brand: 'Gucci',
    newPrice: 450,
    salePrice: 7500,
    condition: 'Like New',
    category: 'Shoes',
    size: 'EU 42',
    isSecondHand: true,
    url: 'https://barkinsayin.com/store/shoes/gucci-gg-leather-espadrilles-blue-eu-42-pre-owned',
    description: 'Gucci GG leather espadrilles in blue with signature logo. Perfect summer luxury footwear.',
    specifications: ['Upper: GG embossed leather', 'Jute rope midsole', 'Rubber outsole', 'Slip-on design', 'Color: Blue', 'EU 42 (US 9 / UK 8)', 'Condition: Like New - minimal wear', 'Care: Wipe leather; avoid prolonged water exposure']
  },
  {
    id: 13,
    name: 'Gucci GG Canvas Espadrilles – Beige/Blue (EU 42, Pre-owned)',
    slug: 'gucci-gg-canvas-espadrilles-beigeblue-eu-42-pre-owned',
    brand: 'Gucci',
    newPrice: 499,
    salePrice: 8500,
    condition: 'Like New',
    category: 'Shoes',
    size: 'EU 42',
    isSecondHand: true,
    url: 'https://barkinsayin.com/store/shoes/gucci-gg-canvas-espadrilles-beigeblue-eu-42-pre-owned',
    description: 'Gucci GG canvas espadrilles in beige and blue. Iconic summer style with jute sole.',
    specifications: ['Upper: GG canvas', 'Jute rope midsole', 'Rubber outsole', 'Slip-on', 'Color: Beige/Blue', 'EU 42', 'Condition: Like New', 'Care: Spot clean canvas']
  },
  {
    id: 14,
    name: 'Valentino Garavani Chunky Sneakers – White/Grey (EU 42, Pre-owned)',
    slug: 'valentino-garavani-chunky-sneakers-whitegrey-eu-42-pre-owned',
    brand: 'Valentino Garavani',
    newPrice: 799,
    salePrice: 10500,
    condition: 'Very Good',
    category: 'Shoes',
    size: 'EU 42',
    isSecondHand: true,
    url: 'https://barkinsayin.com/store/shoes/valentino-garavani-chunky-sneakers-whitegrey-eu-42-pre-owned',
    description: 'Valentino Garavani chunky sneakers in white and grey. Bold sole, premium materials.',
    specifications: ['Upper: Leather/mesh', 'Chunky rubber sole', 'Lace-up', 'Color: White/Grey', 'EU 42', 'Condition: Very Good', 'Care: Wipe clean']
  },
  {
    id: 15,
    name: 'Gucci Rhyton Logo Sneakers – Off-White (EU 42, Pre-owned)',
    slug: 'gucci-rhyton-logo-sneakers-off-white-eu-42-pre-owned',
    brand: 'Gucci',
    newPrice: 799,
    salePrice: 7500,
    condition: 'Good',
    category: 'Shoes',
    size: 'EU 42',
    isSecondHand: true,
    url: 'https://barkinsayin.com/store/shoes/gucci-rhyton-logo-sneakers-off-white-eu-42-pre-owned',
    description: 'Gucci Rhyton sneakers in off-white with vintage Gucci logo print. Chunky retro style.',
    specifications: ['Upper: Leather', 'Gucci logo print', 'Chunky sole', 'Lace-up', 'Color: Off-White', 'EU 42', 'Condition: Good', 'Care: Leather cleaner']
  },
  {
    id: 16,
    name: 'Jimmy Choo "JC Logo" Sneakers – Triple-White (EU 42, Pre-owned)',
    slug: 'jimmy-choo-jc-logo-sneakers-triple-white-eu-42-pre-owned',
    brand: 'Jimmy Choo',
    newPrice: 699,
    salePrice: 6500,
    condition: 'Very Good',
    category: 'Shoes',
    size: 'EU 42',
    isSecondHand: true,
    url: 'https://barkinsayin.com/store/shoes/jimmy-choo-jc-logo-sneakers-triple-white-eu-42-pre-owned',
    description: 'Jimmy Choo triple-white sneakers with JC logo. Luxury streetwear style.',
    specifications: ['Upper: Leather', 'JC logo detail', 'Rubber sole', 'Lace-up', 'Color: Triple White', 'EU 42', 'Condition: Very Good', 'Care: Wipe with damp cloth']
  },
  {
    id: 17,
    name: 'adidas YEEZY Knit Sneaker – Lime/Volt (EU 42, Pre-owned)',
    slug: 'adidas-yeezy-knit-sneaker-limevolt-eu-42-pre-owned',
    brand: 'adidas YEEZY',
    newPrice: 520,
    salePrice: 4500,
    condition: 'Good',
    category: 'Shoes',
    size: 'EU 42',
    isSecondHand: true,
    url: 'https://barkinsayin.com/store/shoes/adidas-yeezy-knit-sneaker-limevolt-eu-42-pre-owned',
    description: 'adidas YEEZY knit sneaker in bold lime/volt colorway. Lightweight, breathable design.',
    specifications: ['Upper: Primeknit', 'Boost midsole', 'Rubber outsole', 'Slip-on style', 'Color: Lime/Volt', 'EU 42', 'Condition: Good', 'Care: Hand wash cold']
  },

  // Giyim
  {
    id: 18,
    name: 'Balmain Padded Logo-Tape Gilet — Black',
    slug: 'balmain-padded-logo-tape-gilet-black',
    brand: 'Balmain',
    newPrice: 750,
    salePrice: 10500,
    condition: 'Like New',
    category: 'Clothing',
    isSecondHand: true,
    url: 'https://barkinsayin.com/store/clothing/balmain-padded-logo-tape-gilet-black',
    description: 'Sleek Balmain puffer gilet with logo tape along placket. Lightweight warmth, high-neck, full zip.',
    specifications: ['Padded sleeveless gilet', 'High neck, full-length zipper', 'Two zip pockets', 'Logo tape: BALMAIN PARIS', 'Shell: Polyamide/Nylon', 'Fill: Down/Feather', 'Size L', 'Condition: Like New', 'Care: Dry clean only']
  },
  {
    id: 19,
    name: 'Lufian Lightweight Puffer Gilet — Black (Second-Hand)',
    slug: 'lufian-lightweight-puffer-gilet-black-second-hand',
    brand: 'Lufian',
    newPrice: 0, // Fiyat belirtilmemiş
    salePrice: 1250,
    condition: 'Like New',
    category: 'Jackets',
    isSecondHand: true,
    url: 'https://barkinsayin.com/store/clothing/lufian-lightweight-puffer-gilet-black-second-hand',
    description: 'Modern lightweight puffer vest for everyday layering. Warm synthetic fill, high neck, full-zip.',
    specifications: ['Lightweight insulated padding', 'High neck, full-length zip', 'Two zip pockets', 'Adjustable hem drawcord', 'Shell: 100% polyamide', 'Fill: Synthetic', 'Size L', 'Condition: Like New', 'Care: Machine wash cold']
  },
  {
    id: 20,
    name: 'Sandro Paris – "Mr. Strong" Crewneck Sweatshirt (Second-Hand)',
    slug: 'sandro-paris-mr-strong-crewneck-sweatshirt-second-hand',
    brand: 'Sandro Paris',
    newPrice: 399,
    salePrice: 5500,
    condition: 'Like New',
    category: 'Clothing',
    isSecondHand: true,
    url: 'https://barkinsayin.com/store/clothing/sandro-paris-mr-strong-crewneck-sweatshirt-second-hand',
    description: 'Cream crewneck sweatshirt with MR. STRONG patch at left chest. Soft, mid-weight, everyday wear.',
    specifications: ['Crewneck; ribbed cuffs and hem', 'Chest patch: MR. STRONG', 'Color: Cream/Beige', 'Fabric: Cotton blend', 'Size M', 'Condition: Very Good/Excellent', 'Care: Wash inside out cold']
  },
  {
    id: 21,
    name: 'Just Cavalli – Graphic Crewneck Sweatshirt (Second-Hand)',
    slug: 'just-cavalli-graphic-crewneck-sweatshirt-second-hand',
    brand: 'Just Cavalli',
    newPrice: 350,
    salePrice: 5500,
    condition: 'Like New',
    category: 'Clothing',
    isSecondHand: true,
    url: 'https://barkinsayin.com/store/clothing/just-cavalli-graphic-crewneck-sweatshirt-second-hand',
    description: 'Black crewneck with large playing-card & green skull graphic. Mid-weight cotton blend.',
    specifications: ['Regular fit crewneck', 'Large front graphic print', 'Ribbed collar, cuffs, hem', 'Color: Black', 'Fabric: Cotton blend', 'Size M', 'Condition: Excellent', 'Care: Wash inside out; do not iron print']
  },
  {
    id: 22,
    name: 'Damat Tween — Classic Blazer / Navy (EU 52, Second-Hand)',
    slug: 'damat-tween-classic-blazer-navy-eu-52-second-hand',
    brand: 'Damat Tween',
    newPrice: 450,
    salePrice: 7500,
    condition: 'Like New',
    category: 'Clothing',
    size: 'EU 52',
    isSecondHand: true,
    url: 'https://barkinsayin.com/store/clothing/damat-tween-classic-blazer-navy-eu-52-second-hand',
    description: 'Clean single-breasted 2-button blazer in navy. Notch lapels, flap pockets. Business or evening.',
    specifications: ['Single-breasted, 2 buttons', 'Notch lapel, chest pocket', 'Two flap hip pockets', 'Fabric: Wool blend', 'Lining: Viscose/Polyester', 'Size: EU 52 (L/XL)', 'Condition: Very Good', 'Care: Dry clean only']
  },
  {
    id: 23,
    name: 'Gucci — Web-Trim Cotton Piqué Polo, Navy (Second-Hand)',
    slug: 'gucci-web-trim-cotton-piqu-polo-navy-second-hand',
    brand: 'Gucci',
    newPrice: 550,
    salePrice: 7500,
    condition: 'Good',
    category: 'T-Shirts',
    isSecondHand: true,
    url: 'https://barkinsayin.com/store/clothing/gucci-web-trim-cotton-piqu-polo-navy-second-hand',
    description: 'Classic Gucci polo in navy cotton piqué with white collar featuring green-red-green Web stripes.',
    specifications: ['100% cotton piqué', 'Contrast white collar with Web stripes', 'Crest patches at collar tips', 'Two-button placket', 'Color: Navy', 'Fit: Regular', 'Condition: Very Good', 'Care: Wash inside out cold']
  },
  {
    id: 24,
    name: 'Balmain — Logo Piqué Polo, Black (Second-Hand)',
    slug: 'balmain-logo-piqu-polo-black-second-hand',
    brand: 'Balmain',
    newPrice: 299,
    salePrice: 3500,
    condition: 'Good',
    category: 'T-Shirts',
    isSecondHand: true,
    url: 'https://barkinsayin.com/store/clothing/balmain-logo-piqu-polo-black-second-hand',
    description: 'Black cotton piqué polo with contrast white piping. Left-chest BALMAIN PARIS embroidery with B crest.',
    specifications: ['100% cotton piqué', 'Contrast tipped collar & cuffs', 'Left-chest logo + B crest', 'Three-button placket', 'Color: Black', 'Fit: Regular', 'Size L', 'Condition: Very Good', 'Care: Wash inside out cold']
  },
  {
    id: 25,
    name: 'Gucci — GG Tape Cotton Piqué Polo, White/Black (Second-Hand)',
    slug: 'gucci-gg-tape-cotton-piqu-polo-whiteblack-second-hand',
    brand: 'Gucci',
    newPrice: 520,
    salePrice: 7000,
    condition: 'Good',
    category: 'T-Shirts',
    isSecondHand: true,
    url: 'https://barkinsayin.com/store/clothing/gucci-gg-tape-cotton-piqu-polo-whiteblack-second-hand',
    description: 'White cotton piqué polo with black collar and GG monogram tape from shoulder to sleeve.',
    specifications: ['100% cotton piqué', 'Shoulder-to-sleeve GG tape', 'Black contrast collar', 'Three-button placket', 'Color: White/Black', 'Fit: Regular', 'Size L', 'Condition: Very Good', 'Care: Wash inside out cold']
  },
  {
    id: 26,
    name: 'Just Cavalli — Graffiti Logo Crewneck Sweatshirt, Beige (Second-Hand)',
    slug: 'just-cavalli-graffiti-logo-crewneck-sweatshirt-beige-second-hand',
    brand: 'Just Cavalli',
    newPrice: 490,
    salePrice: 9500,
    condition: 'Like New',
    category: 'Clothing',
    isSecondHand: true,
    url: 'https://barkinsayin.com/store/clothing/just-cavalli-graffiti-logo-crewneck-sweatshirt-beige-second-hand',
    description: 'Beige crewneck with oversized spray-paint Just Cavalli graphic. Soft, mid-weight, statement layer.',
    specifications: ['Regular-fit crewneck', 'Oversized graffiti logo print', 'Ribbed collar, cuffs, hem', 'Color: Beige/Cream', 'Fabric: Cotton blend', 'Size M', 'Condition: Very Good', 'Care: Wash inside out; do not iron print']
  },
  {
    id: 27,
    name: 'HUGO (by Hugo Boss) — "HEROES" Crewneck Sweatshirt, Black (Size M, Second-Hand)',
    slug: 'hugo-by-hugo-boss-heroes-crewneck-sweatshirt-black-size-m-second-hand',
    brand: 'HUGO',
    newPrice: 150,
    salePrice: 3200,
    condition: 'Very Good',
    category: 'Clothing',
    size: 'M',
    isSecondHand: true,
    url: 'https://barkinsayin.com/store/clothing/hugo-by-hugo-boss-heroes-crewneck-sweatshirt-black-size-m-second-hand',
    description: 'Black crewneck with bold HEROES / David Bowie front print and HUGO red label on sleeve.',
    specifications: ['Regular-fit crewneck', 'Large HEROES chest print', 'Ribbed collar, cuffs, hem', 'Sleeve HUGO red label', 'Color: Black', 'Fabric: Cotton blend', 'Size M', 'Condition: Very Good', 'Care: Wash inside out cold']
  },
  {
    id: 28,
    name: 'Versace Jeans Couture — Baroque Medallion Crewneck Sweatshirt, Black (Size M, Second-Hand)',
    slug: 'versace-jeans-couture-baroque-medallion-crewneck-sweatshirt-black-size-m-second-hand',
    brand: 'Versace Jeans Couture',
    newPrice: 530,
    salePrice: 7500,
    condition: 'Very Good',
    category: 'Clothing',
    size: 'M',
    isSecondHand: true,
    url: 'https://barkinsayin.com/store/clothing/versace-jeans-couture-baroque-medallion-crewneck-sweatshirt-black-size-m-second-hand',
    description: 'Black crewneck with large gold baroque medallion Versace Jeans Couture print. Statement piece.',
    specifications: ['Regular-fit crewneck', 'Bold gold baroque print', 'Ribbed collar, cuffs, hem', 'Color: Black/Gold', 'Fabric: Cotton blend', 'Size M', 'Condition: Very Good', 'Care: Wash inside out; do not iron print']
  },
  {
    id: 29,
    name: 'Versace Jeans Couture — Eagle Baroque Crewneck Sweatshirt, Black/Gold (Size M, Second-Hand)',
    slug: 'versace-jeans-couture-eagle-baroque-crewneck-sweatshirt-blackgold-size-m-second-hand',
    brand: 'Versace Jeans Couture',
    newPrice: 440,
    salePrice: 6500,
    condition: 'Good',
    category: 'Clothing',
    size: 'M',
    isSecondHand: true,
    url: 'https://barkinsayin.com/store/clothing/versace-jeans-couture-eagle-baroque-crewneck-sweatshirt-blackgold-size-m-second-hand',
    description: 'Black crewneck with large gold eagle & baroque crest print. Statement layer for everyday.',
    specifications: ['Regular-fit crewneck', 'Bold gold eagle/baroque print', 'Ribbed collar, cuffs, hem', 'Color: Black/Gold', 'Fabric: Cotton blend', 'Size M', 'Condition: Very Good', 'Care: Wash inside out cold']
  },
  {
    id: 30,
    name: 'Versace Jeans Couture — Patch Logo Crewneck Sweatshirt, Black (Size M, Second-Hand)',
    slug: 'versace-jeans-couture-patch-logo-crewneck-sweatshirt-black-size-m-second-hand',
    brand: 'Versace Jeans Couture',
    newPrice: 520,
    salePrice: 8500,
    condition: 'Very Good',
    category: 'Clothing',
    size: 'M',
    isSecondHand: true,
    url: 'https://barkinsayin.com/store/clothing/versace-jeans-couture-patch-logo-crewneck-sweatshirt-black-size-m-second-hand',
    description: 'Black crewneck with left-chest Versace Jeans Couture patch label. Clean, everyday statement.',
    specifications: ['Regular-fit crewneck', 'Left-chest logo patch', 'Ribbed collar, cuffs, hem', 'Color: Black', 'Fabric: Cotton blend', 'Size M', 'Condition: Very Good', 'Care: Wash inside out; avoid ironing patch']
  },
  {
    id: 31,
    name: 'Just Cavalli — Graffiti Script Crewneck Sweatshirt, Black/White (Size M, Second-Hand)',
    slug: 'just-cavalli-graffiti-script-crewneck-sweatshirt-blackwhite-size-m-second-hand',
    brand: 'Just Cavalli',
    newPrice: 350,
    salePrice: 4500,
    condition: 'Very Good',
    category: 'Clothing',
    size: 'M',
    isSecondHand: true,
    url: 'https://barkinsayin.com/store/clothing/just-cavalli-graffiti-script-crewneck-sweatshirt-blackwhite-size-m-second-hand',
    description: 'Black crewneck with oversized spray-paint Just Cavalli script. Easy statement layer.',
    specifications: ['Regular-fit crewneck', 'Oversized graffiti script print', 'Ribbed collar, cuffs, hem', 'Color: Black/White', 'Fabric: Cotton blend', 'Size M', 'Condition: Very Good', 'Care: Wash inside out; do not iron print']
  },
  {
    id: 32,
    name: 'Versace Jeans Couture — Multicolor Logo Crewneck Sweatshirt, Black (Size M, Second-Hand)',
    slug: 'versace-jeans-couture-multicolor-logo-crewneck-sweatshirt-black-size-m-second-hand',
    brand: 'Versace Jeans Couture',
    newPrice: 520,
    salePrice: 8500,
    condition: 'Very Good',
    category: 'Clothing',
    size: 'M',
    isSecondHand: true,
    url: 'https://barkinsayin.com/store/clothing/versace-jeans-couture-multicolor-logo-crewneck-sweatshirt-black-size-m-second-hand',
    description: 'Black crewneck with large VERSACE JEANS COUTURE chest logo in multicolor block letters.',
    specifications: ['Regular-fit crewneck', 'Oversized multicolor logo print', 'Ribbed collar, cuffs, hem', 'Color: Black/Multicolor', 'Fabric: Cotton blend', 'Size M', 'Condition: Very Good', 'Care: Wash inside out; do not iron print']
  },
  {
    id: 33,
    name: 'PS Paul Smith — Chest-Patch Crewneck Sweatshirt, Black (Size M, Second-Hand)',
    slug: 'ps-paul-smith-chest-patch-crewneck-sweatshirt-black-size-m-second-hand',
    brand: 'PS Paul Smith',
    newPrice: 360,
    salePrice: 5500,
    condition: 'Very Good',
    category: 'Clothing',
    size: 'M',
    isSecondHand: true,
    url: 'https://barkinsayin.com/store/clothing/ps-paul-smith-chest-patch-crewneck-sweatshirt-black-size-m-second-hand',
    description: 'Black crewneck with left-chest PS Paul Smith patch in multicolor artwork.',
    specifications: ['Regular-fit crewneck', 'Left-chest logo/artwork patch', 'Ribbed collar, cuffs, hem', 'Color: Black', 'Fabric: Cotton blend', 'Size M', 'Condition: Very Good', 'Care: Wash inside out; avoid ironing patch']
  },
  {
    id: 34,
    name: 'Just Cavalli — Skull Graphic Crewneck Sweatshirt, Black (Size M, Second-Hand)',
    slug: 'just-cavalli-skull-graphic-crewneck-sweatshirt-black-size-m-second-hand',
    brand: 'Just Cavalli',
    newPrice: 690,
    salePrice: 11500,
    condition: 'Like New',
    category: 'Clothing',
    size: 'M',
    isSecondHand: true,
    url: 'https://barkinsayin.com/store/clothing/just-cavalli-skull-graphic-crewneck-sweatshirt-black-size-m-second-hand',
    description: 'Black crewneck with large skull artwork and JUST CAVALLI logo.',
    specifications: ['Regular-fit crewneck', 'Bold skull front print', 'Ribbed collar, cuffs, hem', 'Color: Black', 'Fabric: Cotton blend', 'Size M', 'Condition: Like New', 'Care: Wash inside out; do not iron print']
  },
  {
    id: 35,
    name: 'Moschino — Logo Patch Hoodie, Black (Size M, Second-Hand)',
    slug: 'moschino-logo-patch-hoodie-black-size-m-second-hand',
    brand: 'Moschino',
    newPrice: 320,
    salePrice: 5500,
    condition: 'Very Good',
    category: 'Clothing',
    size: 'M',
    isSecondHand: true,
    url: 'https://barkinsayin.com/store/clothing/moschino-logo-patch-hoodie-black-size-m-second-hand',
    description: 'Black pullover hoodie with small left-chest MOSCHINO circular logo patch.',
    specifications: ['Regular fit hoodie', 'Drawstring hood', 'Kangaroo pocket', 'Left-chest logo patch', 'Ribbed cuffs, hem', 'Color: Black', 'Fabric: Cotton blend', 'Size M', 'Condition: Very Good']
  },
  {
    id: 36,
    name: 'HUGO (by Hugo Boss) — Reverse Box Logo Crewneck Sweatshirt, Black (Size M, Second-Hand)',
    slug: 'hugo-by-hugo-boss-reverse-box-logo-crewneck-sweatshirt-black-size-m-second-hand',
    brand: 'HUGO',
    newPrice: 190,
    salePrice: 3500,
    condition: 'Very Good',
    category: 'Clothing',
    size: 'M',
    isSecondHand: true,
    url: 'https://barkinsayin.com/store/clothing/hugo-by-hugo-boss-reverse-box-logo-crewneck-sweatshirt-black-size-m-second-hand',
    description: 'Black crewneck with reversed HUGO box logo at chest. Clean street style.',
    specifications: ['Regular-fit crewneck', 'Reverse HUGO chest logo', 'Ribbed collar, cuffs, hem', 'Color: Black', 'Fabric: Cotton blend', 'Size M', 'Condition: Very Good', 'Care: Wash inside out cold']
  },
  {
    id: 37,
    name: 'Just Cavalli — Logo Crewneck Sweatshirt, Black/Beige (Size M, Second-Hand)',
    slug: 'just-cavalli-logo-crewneck-sweatshirt-blackbeige-size-m-second-hand',
    brand: 'Just Cavalli',
    newPrice: 360,
    salePrice: 6500,
    condition: 'Like New',
    category: 'Clothing',
    size: 'M',
    isSecondHand: true,
    url: 'https://barkinsayin.com/store/clothing/just-cavalli-logo-crewneck-sweatshirt-blackbeige-size-m-second-hand',
    description: 'Black crewneck with large JUST CAVALLI chest logo in beige/cream outline.',
    specifications: ['Regular-fit crewneck', 'Bold front logo print', 'Ribbed collar, cuffs, hem', 'Color: Black/Beige', 'Fabric: Cotton blend', 'Size M', 'Condition: Very Good', 'Care: Wash inside out cold']
  },
  {
    id: 38,
    name: 'DSQUARED2 — Distressed Logo Hoodie, Olive/Camo (Size M, Second-Hand)',
    slug: 'dsquared2-distressed-logo-hoodie-olivecamo-size-m-second-hand',
    brand: 'DSQUARED2',
    newPrice: 390,
    salePrice: 4500,
    condition: 'Good',
    category: 'Clothing',
    size: 'M',
    isSecondHand: true,
    url: 'https://barkinsayin.com/store/clothing/dsquared2-distressed-logo-hoodie-olivecamo-size-m-second-hand',
    description: 'Olive hoodie with chest DSQUARED2 logo, distressed details, and camo shoulder panel.',
    specifications: ['Regular fit hoodie', 'Drawstring hood', 'Chest logo print', 'Distressed detailing', 'Camo shoulder panel', 'Color: Olive/Camo', 'Fabric: Cotton blend', 'Size M', 'Condition: Very Good']
  },
  {
    id: 39,
    name: 'Versace Jeans Couture — Embossed/Gold Logo Crewneck Sweatshirt, Black (Size M, Second-Hand)',
    slug: 'versace-jeans-couture-embossedgold-logo-crewneck-sweatshirt-black-size-m-second-hand',
    brand: 'Versace Jeans Couture',
    newPrice: 420,
    salePrice: 5500,
    condition: 'Very Good',
    category: 'Clothing',
    size: 'M',
    isSecondHand: true,
    url: 'https://barkinsayin.com/store/clothing/versace-jeans-couture-embossedgold-logo-crewneck-sweatshirt-black-size-m-second-hand',
    description: 'Black crewneck with all-over embossed text and bold gold logo centered at chest.',
    specifications: ['Regular-fit crewneck', 'All-over embossed text', 'Central gold logo', 'Ribbed collar, cuffs, hem', 'Color: Black/Gold', 'Fabric: Cotton blend', 'Size M', 'Condition: Very Good']
  },
  {
    id: 40,
    name: 'Vakko — Anchor Patch Cotton Piqué Polo, Black (Size L, Second-Hand)',
    slug: 'vakko-anchor-patch-cotton-piqu-polo-black-size-l-second-hand',
    brand: 'Vakko',
    newPrice: 190,
    salePrice: 2500,
    condition: 'Good',
    category: 'T-Shirts',
    size: 'L',
    isSecondHand: true,
    url: 'https://barkinsayin.com/store/clothing/vakko-anchor-patch-cotton-piqu-polo-black-size-l-second-hand',
    description: 'Black cotton piqué polo with tonal collar and beaded anchor patch at hem.',
    specifications: ['100% cotton piqué', 'Ribbed collar & cuffs', 'Two-button placket', 'Anchor patch at hem', 'Color: Black', 'Fit: Regular', 'Size L', 'Condition: Very Good']
  },
  {
    id: 41,
    name: 'Vakko — Striped Cotton Shirt, Beige/White (Size L, Second-Hand)',
    slug: 'vakko-striped-cotton-shirt-beigewhite-size-l-second-hand',
    brand: 'Vakko',
    newPrice: 240,
    salePrice: 3500,
    condition: 'Very Good',
    category: 'Shirts',
    size: 'L',
    isSecondHand: true,
    url: 'https://barkinsayin.com/store/clothing/vakko-striped-cotton-shirt-beigewhite-size-l-second-hand',
    description: 'Classic long-sleeve striped shirt in beige with white vertical pinstripes.',
    specifications: ['100% cotton poplin', 'Point collar', 'Full button placket', 'Single chest pocket', 'Buttoned cuffs', 'Color: Beige/White', 'Fit: Regular', 'Size L', 'Condition: Very Good']
  },
  {
    id: 42,
    name: 'HUGO (by Hugo Boss) — Silver Sequin Dinner Blazer, Black Shawl Lapel (EU 48, Second-Hand)',
    slug: 'hugo-by-hugo-boss-silver-sequin-dinner-blazer-black-shawl-lapel-eu-48-second-hand',
    brand: 'HUGO',
    newPrice: 290,
    salePrice: 4000,
    condition: 'Like New',
    category: 'Clothing',
    size: 'EU 48',
    isSecondHand: true,
    url: 'https://barkinsayin.com/store/clothing/hugo-by-hugo-boss-silver-sequin-dinner-blazer-black-shawl-lapel-eu-48-second-hand',
    description: 'Statement evening blazer with full silver sequin shell and black shawl lapel.',
    specifications: ['Single-breasted, 1-button', 'Shawl lapel', 'Two jetted pockets', 'Shell: Polyester with sequins', 'Fully lined', 'Size: EU 48 (M)', 'Condition: Very Good', 'Care: Dry clean only']
  },
  {
    id: 43,
    name: 'Beymen — Houndstooth Wool-Blend Blazer, Grey (EU 52, Second-Hand)',
    slug: 'beymen-houndstooth-wool-blend-blazer-grey-eu-52-second-hand',
    brand: 'Beymen',
    newPrice: 490,
    salePrice: 8500,
    condition: 'Like New',
    category: 'Clothing',
    size: 'EU 52',
    isSecondHand: true,
    url: 'https://barkinsayin.com/store/clothing/beymen-houndstooth-wool-blend-blazer-grey-eu-52-second-hand',
    description: 'Grey/black houndstooth blazer. Sharp notch lapels, flap pockets.',
    specifications: ['2-button', 'Notch lapel', 'Wool blend', 'Size: EU 52', 'Condition: Like New', 'Care: Dry clean']
  },
  {
    id: 44,
    name: 'Abdullah Kiğılı Exclusive — Checked Wool-Blend Blazer, Navy (EU 52, Second-Hand)',
    slug: 'abdullah-kil-exclusive-checked-wool-blend-blazer-navy-eu-52-second-hand',
    brand: 'Abdullah Kiğılı Exclusive',
    newPrice: 320,
    salePrice: 6500,
    condition: 'Like New',
    category: 'Clothing',
    size: 'EU 52',
    isSecondHand: true,
    url: 'https://barkinsayin.com/store/clothing/abdullah-kil-exclusive-checked-wool-blend-blazer-navy-eu-52-second-hand',
    description: 'Navy check blazer with off-white overcheck. Clean notch lapels.',
    specifications: ['2-button', 'Notch lapel', 'Wool blend', 'Size: EU 52', 'Condition: Like New', 'Care: Dry clean']
  },
  {
    id: 45,
    name: 'Abdullah Kiğılı Exclusive — Windowpane Wool-Blend Blazer, Grey/Navy (EU 52, Second-Hand)',
    slug: 'abdullah-kil-exclusive-windowpane-wool-blend-blazer-greynavy-eu-52-second-hand',
    brand: 'Abdullah Kiğılı Exclusive',
    newPrice: 320,
    salePrice: 6500,
    condition: 'Like New',
    category: 'Clothing',
    size: 'EU 52',
    isSecondHand: true,
    url: 'https://barkinsayin.com/store/clothing/abdullah-kil-exclusive-windowpane-wool-blend-blazer-greynavy-eu-52-second-hand',
    description: 'Grey blazer with bold navy windowpane check. Sharp for business.',
    specifications: ['2-button', 'Notch lapel', 'Wool blend', 'Size: EU 52', 'Condition: Like New', 'Care: Dry clean']
  },
  {
    id: 46,
    name: 'Just Cavalli — "West Coast" Graphic Hoodie, Beige (Size M, Second-Hand)',
    slug: 'just-cavalli-west-coast-graphic-hoodie-beige-size-m-second-hand',
    brand: 'Just Cavalli',
    newPrice: 370,
    salePrice: 7500,
    condition: 'Like New',
    category: 'Clothing',
    size: 'M',
    isSecondHand: true,
    url: 'https://barkinsayin.com/store/clothing/just-cavalli-west-coast-graphic-hoodie-beige-size-m-second-hand',
    description: 'Beige hoodie with eagle West Coast graphic and braided drawcords.',
    specifications: ['Regular fit', 'Front graphic', 'Kangaroo pocket', 'Color: Beige', 'Size M', 'Condition: Like New']
  },
  {
    id: 47,
    name: 'Porsche Design — Quilted Stand-Collar Jacket, Black (EU 52, Second-Hand)',
    slug: 'porsche-design-quilted-stand-collar-jacket-black-eu-52-second-hand',
    brand: 'Porsche Design',
    newPrice: 280,
    salePrice: 4500,
    condition: 'Very Good',
    category: 'Jackets',
    size: 'EU 52',
    isSecondHand: true,
    url: 'https://barkinsayin.com/store/clothing/porsche-design-quilted-stand-collar-jacket-black-eu-52-second-hand',
    description: 'Lightweight quilted jacket with stand collar and technical paneling.',
    specifications: ['Stand collar', 'Zip front', '2 zip pockets', 'Size: EU 52', 'Condition: Very Good', 'Care: Machine wash']
  },
  {
    id: 48,
    name: 'Alpha Industries — B-15 Inspired Flight Jacket, Sage Green (Size M, Second-Hand)',
    slug: 'alpha-industries-b-15-inspired-flight-jacket-sage-green-size-m-second-hand',
    brand: 'Alpha Industries',
    newPrice: 360,
    salePrice: 8500,
    condition: 'Like New',
    category: 'Jackets',
    size: 'M',
    isSecondHand: true,
    url: 'https://barkinsayin.com/store/clothing/alpha-industries-b-15-inspired-flight-jacket-sage-green-size-m-second-hand',
    description: 'Classic flight jacket in sage green with faux-shearling collar and RBF ribbon.',
    specifications: ['Water-resistant nylon', 'Faux-shearling collar', 'Sleeve utility pocket', 'Color: Sage Green', 'Size M', 'Condition: Like New']
  },
  {
    id: 49,
    name: 'HUGO BOSS — Wool-Blend Tweed Blazer, Dark Brown/Black (EU 52, Second-Hand)',
    slug: 'hugo-boss-wool-blend-tweed-blazer-dark-brownblack-eu-52-second-hand',
    brand: 'HUGO BOSS',
    newPrice: 399,
    salePrice: 8500,
    condition: 'Like New',
    category: 'Clothing',
    size: 'EU 52',
    isSecondHand: true,
    url: 'https://barkinsayin.com/store/clothing/hugo-boss-wool-blend-tweed-blazer-dark-brownblack-eu-52-second-hand',
    description: 'Dark brown/black tweed blazer. Notch lapels, flap pockets.',
    specifications: ['2-button', 'Notch lapel', 'Wool blend tweed', 'Size: EU 52', 'Condition: Like New', 'Care: Dry clean']
  },
  {
    id: 50,
    name: 'Fred Perry — Taped Track Jacket, Dark Green/Gold (Size L, Second-Hand)',
    slug: 'fred-perry-taped-track-jacket-dark-greengold-size-l-second-hand',
    brand: 'Fred Perry',
    newPrice: 115,
    salePrice: 1800,
    condition: 'Like New',
    category: 'Jackets',
    size: 'L',
    isSecondHand: true,
    url: 'https://barkinsayin.com/store/clothing/fred-perry-taped-track-jacket-dark-greengold-size-l-second-hand',
    description: 'Dark green track jacket with laurel-wreath tape and gold logo.',
    specifications: ['Full zip', 'Stand collar', 'Laurel-wreath tape', 'Color: Dark Green/Gold', 'Size L', 'Condition: Like New']
  },
  {
    id: 51,
    name: 'Balmain — Monogram Zip Bomber Jacket, Black (Size L, Second-Hand)',
    slug: 'balmain-monogram-zip-bomber-jacket-black-size-l-second-hand',
    brand: 'Balmain',
    newPrice: 490,
    salePrice: 7500,
    condition: 'Very Good',
    category: 'Jackets',
    size: 'L',
    isSecondHand: true,
    url: 'https://barkinsayin.com/store/clothing/balmain-monogram-zip-bomber-jacket-black-size-l-second-hand',
    description: 'Black bomber with all-over BALMAIN PARIS monogram and B crest.',
    specifications: ['Full zip', 'All-over monogram', 'B crest badge', 'Ribbed trims', 'Color: Black', 'Size L', 'Condition: Very Good']
  },
  {
    id: 52,
    name: 'Balmain — Logo T-Shirt with Monogram Sleeve Trim, Black (Size L, Second-Hand)',
    slug: 'balmain-logo-t-shirt-with-monogram-sleeve-trim-black-size-l-second-hand',
    brand: 'Balmain',
    newPrice: 300,
    salePrice: 4500,
    condition: 'Very Good',
    category: 'T-Shirts',
    size: 'L',
    isSecondHand: true,
    url: 'https://barkinsayin.com/store/clothing/balmain-logo-t-shirt-with-monogram-sleeve-trim-black-size-l-second-hand',
    description: 'Black crewneck tee with BALMAIN chest logo and monogram tape on sleeves.',
    specifications: ['Crewneck', 'Chest logo', 'Monogram sleeve tape', 'Color: Black', '100% cotton', 'Size L', 'Condition: Very Good']
  },
  {
    id: 53,
    name: 'Balmain — Logo T-Shirt & Swim Shorts Set, Black (T-Shirt M, Shorts L, Second-Hand)',
    slug: 'balmain-logo-t-shirt-swim-shorts-set-black-t-shirt-m-shorts-l-second-hand',
    brand: 'Balmain',
    newPrice: 350,
    salePrice: 5500,
    condition: 'Very Good',
    category: 'Special',
    size: 'M/L',
    isSecondHand: true,
    url: 'https://barkinsayin.com/store/clothing/balmain-logo-t-shirt-swim-shorts-set-black-t-shirt-m-shorts-l-second-hand',
    description: 'Coordinated set: cotton logo tee + swim shorts, both with B crest.',
    specifications: ['T-shirt: Size M', 'Shorts: Size L', 'B crest patches', 'Color: Black', 'Condition: Very Good']
  },
  {
    id: 54,
    name: 'Balmain — Paris Logo T-Shirt, Black (Size M, Second-Hand)',
    slug: 'balmain-paris-logo-t-shirt-black-size-m-second-hand',
    brand: 'Balmain',
    newPrice: 300,
    salePrice: 4500,
    condition: 'Very Good',
    category: 'T-Shirts',
    size: 'M',
    isSecondHand: true,
    url: 'https://barkinsayin.com/store/clothing/balmain-paris-logo-t-shirt-black-size-m-second-hand',
    description: 'Black crewneck with bold BALMAIN PARIS front print and B emblem.',
    specifications: ['Crewneck', 'Front logo + B crest', 'Color: Black/White', '100% cotton', 'Size M', 'Condition: Very Good']
  },
  {
    id: 55,
    name: 'Balmain — Crest Patch Cotton Piqué Polo, Black (Size M, Second-Hand)',
    slug: 'balmain-crest-patch-cotton-piqu-polo-black-size-m-second-hand',
    brand: 'Balmain',
    newPrice: 190,
    salePrice: 3200,
    condition: 'Good',
    category: 'T-Shirts',
    size: 'M',
    isSecondHand: true,
    url: 'https://barkinsayin.com/store/clothing/balmain-crest-patch-cotton-piqu-polo-black-size-m-second-hand',
    description: 'Black cotton piqué polo with tonal B crest patch at chest.',
    specifications: ['100% cotton piqué', 'Chest B crest patch', '3-button placket', 'Color: Black', 'Size M', 'Condition: Good']
  },
  {
    id: 56,
    name: 'Sertaç Taşdelen — Summer Set (Top & Trousers), Ecru/Stone (Size L, Second-Hand)',
    slug: 'serta-tadelen-summer-set-top-trousers-ecrustone-size-l-second-hand',
    brand: 'Sertaç Taşdelen',
    newPrice: 450,
    salePrice: 6500,
    condition: 'Very Good',
    category: 'Special',
    size: 'L',
    isSecondHand: true,
    url: 'https://barkinsayin.com/store/clothing/serta-tadelen-summer-set-top-trousers-ecrustone-size-l-second-hand',
    description: 'Lightweight two-piece: hooded top + elastic-waist trousers in ecru/stone.',
    specifications: ['Hooded top', 'Elastic-waist trousers', 'Breathable fabric', 'Color: Ecru/Stone', 'Size L', 'Condition: Very Good']
  },
  {
    id: 57,
    name: 'Sertaç Taşdelen — Summer Set (V-Neck Top & Trousers), White (Size L, Second-Hand)',
    slug: 'serta-tadelen-summer-set-v-neck-top-trousers-white-size-l-second-hand',
    brand: 'Sertaç Taşdelen',
    newPrice: 450,
    salePrice: 6500,
    condition: 'Very Good',
    category: 'Special',
    size: 'L',
    isSecondHand: true,
    url: 'https://barkinsayin.com/store/clothing/serta-tadelen-summer-set-v-neck-top-trousers-white-size-l-second-hand',
    description: 'Airy two-piece: V-neck top + elastic-waist trousers in white.',
    specifications: ['V-neck top', 'Elastic-waist trousers', 'Breathable fabric', 'Color: White', 'Size L', 'Condition: Very Good']
  },
  {
    id: 58,
    name: 'AllSaints — Palm Collage Camp-Collar Shirt (L, Second-Hand)',
    slug: 'allsaints-palm-collage-camp-collar-shirt-l-second-hand',
    brand: 'AllSaints',
    newPrice: 130,
    salePrice: 1500,
    condition: 'Very Good',
    category: 'Shirts',
    size: 'L',
    isSecondHand: true,
    url: 'https://barkinsayin.com/store/clothing/allsaints-palm-collage-camp-collar-shirt-l-second-hand',
    description: 'Relaxed short-sleeve shirt in muted beige/grey photo-collage print with leopard accents.',
    specifications: ['Camp collar', 'Short sleeves', 'All-over print', 'Color: Beige/Grey', 'Size L', 'Condition: Very Good']
  },
  {
    id: 59,
    name: 'Represent — Oversize T-Shirt + 2x Shorts Set, Cream/Beige + Black (Size L, Second-Hand)',
    slug: 'represent-oversize-t-shirt-2x-shorts-set-creambeige-black-size-l-second-hand',
    brand: 'Represent',
    newPrice: 180,
    salePrice: 4500,
    condition: 'Like New',
    category: 'Special',
    size: 'L',
    isSecondHand: true,
    url: 'https://barkinsayin.com/store/clothing/represent-oversize-t-shirt-2x-shorts-set-creambeige-black-size-l-second-hand',
    description: 'Streetwear set: oversize cream tee + beige shorts + black shorts (gift).',
    specifications: ['Oversize tee (L)', '2x shorts (L)', 'Contrast R logo', 'Color: Cream/Beige/Black', 'Condition: Like New']
  },
  {
    id: 60,
    name: 'Baldessarini — Short-Sleeve Camp-Collar Shirt, Bird/Floral Print (Size M, Second-Hand)',
    slug: 'baldessarini-short-sleeve-camp-collar-shirt-birdfloral-print-size-m-second-hand',
    brand: 'Baldessarini',
    newPrice: 190,
    salePrice: 4600,
    condition: 'Like New',
    category: 'Shirts',
    size: 'M',
    isSecondHand: true,
    url: 'https://barkinsayin.com/store/clothing/baldessarini-short-sleeve-camp-collar-shirt-birdfloral-print-size-m-second-hand',
    description: 'Lightweight summer shirt with relaxed camp collar and bird/botanical print.',
    specifications: ['Camp collar', 'Short sleeves', 'All-over print', 'Color: Cream/Blue/Olive', 'Size M', 'Condition: Like New']
  },
  {
    id: 61,
    name: 'Just Cavalli Short-Sleeve Shirt – Python Print (Size M, Pre-owned)',
    slug: 'just-cavalli-short-sleeve-shirt-python-print-size-m-pre-owned',
    brand: 'Just Cavalli',
    newPrice: 320,
    salePrice: 5500,
    condition: 'Very Good',
    category: 'Shirts',
    size: 'M',
    isSecondHand: true,
    url: 'https://barkinsayin.com/store/clothing/just-cavalli-short-sleeve-shirt-python-print-size-m-pre-owned',
    description: 'Statement short-sleeve shirt with all-over python/snake print and chest pocket.',
    specifications: ['Button-front', 'Camp collar', 'All-over snake print', 'Chest pocket', 'Color: Black/Grey', 'Size M', 'Condition: Very Good']
  },
  {
    id: 62,
    name: 'Versace Jeans Couture Oversize Shirt – White (Size L, Pre-owned)',
    slug: 'versace-jeans-couture-oversize-shirt-white-size-l-pre-owned',
    brand: 'Versace Jeans Couture',
    newPrice: 390,
    salePrice: 4500,
    condition: 'Good',
    category: 'Shirts',
    size: 'L',
    isSecondHand: true,
    url: 'https://barkinsayin.com/store/clothing/versace-jeans-couture-oversize-shirt-white-size-l-pre-owned',
    description: 'Oversized white shirt with relaxed fit. Modern streetwear silhouette.',
    specifications: ['Oversize fit', 'Button-front', 'Long sleeves', 'Color: White', 'Size L', 'Condition: Good']
  }
];

// Ürün arama fonksiyonu
export const findProductBySlug = (slug: string): ProductData | undefined => {
  return updatedProductData.find(product => product.slug === slug);
};

// Kategoriye göre ürünleri filtreleme
export const getProductsByCategory = (category: 'Shoes' | 'Clothing' | 'Jackets' | 'Shirts' | 'T-Shirts' | 'Special'): ProductData[] => {
  return updatedProductData.filter(product => product.category === category);
};

// Kondisyona göre ürünleri filtreleme
export const getProductsByCondition = (condition: string): ProductData[] => {
  if (condition === 'all') return updatedProductData;
  return updatedProductData.filter(product => product.condition === condition);
};
